var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlexible({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104.17 104.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #039;\n      }\n\n      .cls-2 {\n        fill: #00cc87;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 85.06,
    cy: 52.45,
    r: 15.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M98.26,91.94h-32.13c-1.69,0-3.05,1.37-3.05,3.05v6.1c0,1.69,1.37,3.05,3.05,3.05h32.13c1.69,0,3.05-1.37,3.05-3.05v-6.1c0-1.69-1.37-3.05-3.05-3.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M101.12,73.68h-32.13c-1.69,0-3.05,1.37-3.05,3.05v6.1c0,1.69,1.37,3.05,3.05,3.05h32.13c1.69,0,3.05-1.37,3.05-3.05v-6.1c0-1.69-1.37-3.05-3.05-3.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.93,67.57h4.08c-3.9-3.87-6.32-9.24-6.32-15.16,0-2.32.37-4.55,1.06-6.64H13.63c-1.69,0-3.05-1.37-3.05-3.05,0-1.17.66-2.19,1.63-2.7v-12.76c0-1.69,1.37-3.05,3.05-3.05s3.05,1.37,3.05,3.05v12.4h5.9V15.67c0-1.69,1.37-3.05,3.05-3.05s3.05,1.37,3.05,3.05v24.01h5.9v-19.4c0-1.69,1.37-3.05,3.05-3.05s3.05,1.37,3.05,3.05v19.4h5.9v-17.29c0-1.69,1.37-3.05,3.05-3.05s3.05,1.37,3.05,3.05v17.29h5.9V15.26c0-1.69,1.37-3.05,3.05-3.05s3.05,1.37,3.05,3.05v24.77h1.33c2.65-3.71,6.45-6.54,10.87-7.96V3.05c0-1.69-1.37-3.05-3.05-3.05H3.05C1.37,0,0,1.37,0,3.05v98.07c0,1.69,1.37,3.05,3.05,3.05h53.92s0-.02,0-.03v-12.21c0-2.2,1.17-4.13,2.91-5.2-.04-.28-.06-.56-.06-.85v-12.21c0-3.37,2.73-6.1,6.1-6.1ZM30.52,88.5h-15.26c-1.69,0-3.05-1.37-3.05-3.05s1.37-3.05,3.05-3.05h15.26c1.69,0,3.05,1.37,3.05,3.05s-1.37,3.05-3.05,3.05ZM51.47,76.3H15.26c-1.69,0-3.05-1.37-3.05-3.05s1.37-3.05,3.05-3.05h36.22c1.69,0,3.05,1.37,3.05,3.05s-1.37,3.05-3.05,3.05ZM51.47,64.09H15.26c-1.69,0-3.05-1.37-3.05-3.05s1.37-3.05,3.05-3.05h36.22c1.69,0,3.05,1.37,3.05,3.05s-1.37,3.05-3.05,3.05Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlexible);
export default __webpack_public_path__ + "static/media/flexible.4fa7031fe425425f9436df742d54eca5.svg";
export { ForwardRef as ReactComponent };